import { render, staticRenderFns } from "./PasswordDialog.vue?vue&type=template&id=0c50d841&scoped=true"
import script from "./PasswordDialog.vue?vue&type=script&lang=js"
export * from "./PasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./PasswordDialog.vue?vue&type=style&index=0&id=0c50d841&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c50d841",
  null
  
)

export default component.exports